export default {
    data() {
        return {
        }
    },
    mounted() {
        if(typeof(this.$gtag) !== 'undefined') {
            // GA4 Enhanced Ecommerce purchase event
            this.$gtag.event('purchase', {
                "transaction_id": this.order?.reference ? this.order.reference : '',
                "affiliation": this.webName ? this.webName : '',
                "value": parseFloat(this.order?.total) || 0.00,
                "currency": "GBP",
                "tax": parseFloat(this.order?.tax) || 0.00,
                "coupon": this.order?.discount_codes ? this.order.discount_codes : '',
                "shipping": parseFloat(this.order?.delivery_amount) || 0.00,
                "items": this.purchasedItems
            });

            if(this.googleAdsId) {
                this.$gtag.event('conversion', {
                    'send_to': this.googleAdsId,
                    'value': parseFloat(this.order?.total) || 0.00,
                    'currency': 'GBP',
                    'transaction_id': this.order?.reference ? this.order.reference : '',
                });
            }

            // console.log('GA4 Enhanced Ecommerce purchase tracking sent:', {
            //     transaction_id: this.order?.reference,
            //     value: this.order?.total,
            //     items_count: this.purchasedItems.length
            // });
        }
        else {
            console.log('gtag not loaded - purchase tracking skipped');
        }

        // PriceShape API (Send Sale)
        window.PRICESHAPE = window.PRICESHAPE || [];
        _.forEach(this.order?.products, function(product, key) {
            if(product.product_type === 'product') {
                window.PRICESHAPE.itemsSold([
                    { upi: String(product.st_code), itemsSold: product.quantity, uniqueSales: 1},
                ])
            }
        });
    },
    methods: {
        trackFailure() {
            
        }
    },
    computed: {
        purchasedItems() {
            var products = [];
            let vm = this;

            _.forEach(this.order?.products, function(product, key) {
                // Only add to GA if backend has validated it's ready
                if (product.google_analytics_ready) {
                    products.push({
                        'item_id': product.item_id,
                        'item_name': product.item_name,
                        'item_brand': product.brand,
                        'item_category': product.price_range || 'Tyres',
                        'quantity': parseInt(product.quantity) || 1,
                        'price': parseFloat(product.retail) || 0.00,
                        'coupon': vm.order?.discount_codes ? vm.order.discount_codes : '',
                        'currency': 'GBP'
                    });
                }
            });

            if(this.order?.mobile_fitting_amount > 0.00) {
                products.push({
                    'item_id': 'MOBILE_FITTING',
                    'item_name': 'Mobile Fitting Service',
                    'item_category': 'Services',
                    'quantity': 1,
                    'price': parseFloat(this.order?.mobile_fitting_amount) || 0.00,
                    'currency': 'GBP'
                });
            }

            return products;
        }
    }
};